import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Auth } from '@aws-amplify/auth';
import QRCode from 'qrcode';
import { AuthService } from '../auth/auth.service';
import { CommonUtil } from '../util/common-util';
import { Constant } from '../constant';

interface PosterSchedule { date: string; endDate?: string; start: string; end: string; }

@Component({
  selector: 'app-attendance-qr-poster',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './attendance-qr-poster.component.html',
  styleUrl: './attendance-qr-poster.component.css',
})
export class AttendanceQrPosterComponent implements OnInit {
  eventId = 0;
  title = '';
  schedules: PosterSchedule[] = [];
  qrDataUrl = '';
  showSpinner = true;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private commonUtil: CommonUtil,
  ) {}

  ngOnInit(): void {
    this.eventId = Number(this.route.snapshot.paramMap.get('id'));
    this.load();
  }

  get participantUrl(): string {
    return `${location.origin}/attendance/${encodeURIComponent(localStorage.getItem(Constant.lsCompanyCode) || '')}/${this.eventId}`;
  }

  back(): void {
    this.router.navigate(['/myevent-detail', this.eventId, 'attendance']);
  }

  print(): void { window.print(); }

  scheduleLabel(item: PosterSchedule): string {
    const date = String(item.date).slice(0, 10);
    const [year, month, day] = date.split('-').map(Number);
    const weekday = new Intl.DateTimeFormat('ja-JP', { weekday: 'short' }).format(new Date(year, month - 1, day));
    return `${year}年${month}月${day}日（${weekday}） ${String(item.start).slice(0, 5)}〜${item.endDate && item.endDate !== date ? item.endDate.replaceAll('-','/')+' ' : ''}${String(item.end).slice(0, 5)}`;
  }

  private async load(): Promise<void> {
    this.showSpinner = true;
    this.errorMessage = '';
    try {
      const session = await Auth.currentSession();
      const options: any = this.auth.createApiHeader(session);
      options.body = { id: this.eventId };
      const response = await this.commonUtil.apiPost('/myevent/attendance/admin', options);
      this.title = response.data.title;
      this.schedules = response.data.schedules || [];
      this.qrDataUrl = await QRCode.toDataURL(this.participantUrl, {
        type: 'image/png', width: 720, margin: 4, errorCorrectionLevel: 'M',
        color: { dark: '#000000', light: '#ffffff' },
      });
    } catch (err: any) {
      this.errorMessage = err?.error?.message || err?.message || '掲示用QRを表示できませんでした。';
    } finally {
      this.showSpinner = false;
    }
  }
}
